import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[revDynamicModalContent]',
	standalone: false,
})
export class DynamicModalContentDirective {

	constructor(
		public viewContainerRef: ViewContainerRef,
	) {
	}

}
